export const AUTH_TOKENS_UPDATED_EVENT = 'auth:tokens-updated';
export const AUTH_LOGGED_OUT_EVENT = 'auth:logged-out';

function dispatchAuthEvent(name, detail) {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(name, { detail }));
}

export function getStoredAccessToken() {
  return localStorage.getItem('access_token');
}

export function getStoredRefreshToken() {
  return localStorage.getItem('refresh_token');
}

export function setStoredTokens({ access, refresh }) {
  if (access) {
    localStorage.setItem('access_token', access);
  }

  if (refresh) {
    localStorage.setItem('refresh_token', refresh);
  }

  dispatchAuthEvent(AUTH_TOKENS_UPDATED_EVENT, {
    access: access ?? getStoredAccessToken(),
    refresh: refresh ?? getStoredRefreshToken(),
  });
}

export function clearStoredTokens() {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  dispatchAuthEvent(AUTH_LOGGED_OUT_EVENT, null);
}